<template>
    <div v-if="mobileVideoId || landscapeVideoId" class="c-startpage-avatar-cloudflare">
        <!-- MOBILE -->
        <div v-if="mobileVideoId" class="cloudflare-player sm:hidden" :data-type="mobileVideoAspectRatio">
            <iframe
                :src="getVideoUrl(mobileVideoId)"
                title="Cloudflare Video – Hochformat"
                loading="lazy"
                referrerpolicy="strict-origin-when-cross-origin"
                allow="accelerometer; gyroscope; encrypted-media; picture-in-picture"
                allowfullscreen
            />
        </div>
        <!-- DESKTOP -->
        <div v-if="landscapeVideoId" class="cloudflare-player hidden md:block" data-type="quer">
            <iframe
                :src="getVideoUrl(landscapeVideoId)"
                title="Cloudflare Video – Querformat"
                loading="lazy"
                referrerpolicy="strict-origin-when-cross-origin"
                allow="accelerometer; gyroscope; encrypted-media; picture-in-picture"
                allowfullscreen
            />
        </div>
    </div>
</template>

<script setup lang="ts">
interface CloudflareVideo {
    landscapeVideo?: { value?: unknown };
    portraitVideo?: { value?: unknown };
}

const props = defineProps<{ video?: CloudflareVideo }>();

const getVideoId = (value: unknown): string => (typeof value === 'string' ? value.trim() : '');
const landscapeVideoId = computed(() => getVideoId(props.video?.landscapeVideo?.value));
const portraitVideoId = computed(() => getVideoId(props.video?.portraitVideo?.value));
const mobileVideoId = computed(() => portraitVideoId.value || landscapeVideoId.value);
const mobileVideoAspectRatio = computed(() => (portraitVideoId.value ? 'hoch' : 'quer'));

const getVideoUrl = (videoId: string): string => `https://iframe.videodelivery.net/${videoId}`;
</script>

<style lang="postcss">
.cloudflare-player {
    width: 100%;
    aspect-ratio: 16 / 9;
}

.cloudflare-player[data-type='hoch'] {
    aspect-ratio: 9 / 16;
}

.cloudflare-player iframe {
    display: block;
    width: 100%;
    height: 100%;
    border: 0;
    border-radius: 12px;
}
</style>
